import React from 'react'
import Head from 'next/head'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'
import { faHandHoldingUsd, faShieldCheck } from '@fortawesome/pro-duotone-svg-icons'
import { CityData } from './index'
import Layout from '../Layout'
import { MinorCityTitleSection } from '../MinorCityTitleSection'
import { FeatureBySection } from '../FeatureBySection'
import { MinorCitySecondSection } from '../MinorCitySecondSection'
import { ListYelpDataSection } from '../ZipsPage/ListYelpDataSection'
import { MinorCityFourthSection } from '../SEMPage/MinorCityFourthSection'
import { OtherCitiesSection } from '../ServicesPage/OtherCitiesSection'

const MinorCityPageTemplate: React.FC<{
  cityName: string
  state: string
  cities: CityData[]
  yelpData: any
  rating: string
  reviewCount: number
}> = ({ cityName, state, cities, yelpData }) => {
  return (
    <Layout title={`Brake Repair Near Me in ${cityName} - NuBrakes Mobile Brake Repair`}>
      <Head>
        <meta
          name="description"
          content={`Find brake repair services near me in ${cityName}, ${state}. Schedule a brake repair service online in minutes.`}
        />
      </Head>
      <MinorCityTitleSection
        title={`Schedule Affordable Brake Repair in ${cityName}, ${state}`}
        subheading={`The most convenient brake repair in ${cityName} - delivered at your office or home`}
        buttonText={`Get A Free Brake Repair Estimate`}
      />
      <FeatureBySection />
      <MinorCitySecondSection
        firstReasonWhy={{
          title: 'REPAIRS AROUND YOUR SCHEDULE',
          subheading:
            'Life’s busy. So why waste your time sitting at a shop? Our brake techs come to you and repair your brakes around your schedule.',
          icon: faWrench,
        }}
        secondReasonWhy={{
          title: 'TRANSPARENT, AFFORDABLE PRICING',
          subheading:
            'Our upfront, no-obligation brake repair quotes are designed to give you a transparent view into your vehicle’s repair costs.',
          icon: faHandHoldingUsd,
        }}
        thirdReasonWhy={{
          title: 'HAPPINESS GUARANTEED',
          subheading:
            'Our brake techs have decades of combined experience, and all services are backed by our NuBrakes Guarantee.',
          icon: faShieldCheck,
        }}
        subheading={`Our mission is to provide ultra-convenient, transparent brake services in ${cityName} for less.`}
        title={`WE MAKE BRAKE REPAIR SIMPLE IN ${cityName}`}
      />
      <ListYelpDataSection
        locationName={`${cityName}, ${state}`}
        subheading={`Looking for the top-rated brake shop near me in ${cityName}?`}
        businesses={yelpData}
      />
      <MinorCityFourthSection
        title={`A Better Brake Shop Experience Delivered in Your Driveway.`}
        subheading={`Our mobile brake repair technicians provide top-rated, certified brake services from the comfort of your home or office.`}
      />
      <OtherCitiesSection mainCities={cities} />
    </Layout>
  )
}

export default MinorCityPageTemplate
